module.exports = __webpack_public_path__ + "img/caja-sullana.45b8ded3.svg";